import { Component } from '@angular/core';

@Component({
  selector: 'app-employee-dashboard2',
  standalone: true,
  imports: [],
  templateUrl: './employee-dashboard2.component.html',
  styleUrl: './employee-dashboard2.component.scss'
})
export class EmployeeDashboard2Component {

}
